export default {
  dialogBase: {
    ariaLabel: 'Sharing dialog',
    button: {
      copiedToClipboard: 'Link copied to clipboard!',
      copyLinkTooltip: 'Share your {asset} with others to enable this option'
    },
    header: {
      ariaLabel: 'Sharing dialog header',
      title: 'Share {assetTitle}'
    },
    content: {
      ariaLabel: 'Sharing dialog content',
      whoHasAccessLabel: 'Who has access',
      notSharedYet: '(Not shared yet)',
      memberCount: '({count} {count, plural, one {member} other {members}})',
      groupCount: '({count} {count, plural, one {group} other {groups}})',
      membersAndGroups:
        '({userCount} {userCount, plural, one {member} other {members}} and {groupCount} {groupCount, plural, one {group} other {groups}})',
      allMemberCount: '(all {count} {count, plural, one {member} other {members}})',
      allGroupCount: '(all {count} {count, plural, one {group} other {groups}})',
      allMembersAndGroups:
        '(all {userCount} {userCount, plural, one {member} other {members}} and {groupCount} {groupCount, plural, one {group} other {groups}})',
      anyoneInOrganization: 'Anyone in {orgName}',
      organizationMembers: '{count} {count, plural, one {member} other {members}}',
      ownerLabel: 'Owner',
      groupLabel: 'Group',
      inheritedAccessTooltip: 'Access is inherited from an upper level.'
    },
    footer: {
      confirmationTitle: 'Are you sure you want to close?',
      ariaLabel: 'Sharing dialog footer'
    },
    notification: {
      accessRevoked: 'Access revoked',
      removedFromList: 'Removed from the list',
      accessUpdated: 'Access updated'
    }
  },
  types: {
    restricted: 'Restricted',
    organization: 'Organization',
    public: 'Public'
  },
  sharingType: {
    restrictedDescription: 'Only invited people have access',
    menu: {
      restrictedLabel: 'Only invited users can view',
      organizationLabel: 'Users at your organization can view',
      publicLabel: 'Anyone with the link can view'
    },
    organizationDescription: 'Anyone in {orgName} has access',
    publicDescription: 'Anyone with the link can view'
  },
  selector: {
    placeholder: 'Add members or guests',
    placeholderWithGroups: 'Add members, guests or groups',
    noOptionsText: 'Start typing an email to search...',
    noOptionsTextWithGroups: 'Start typing an email or group alias to search...',
    usersGroupHeader: 'Users',
    groupsGroupHeader: 'Groups',
    usersGroupsSelector: {
      notFound: 'No users or groups matching your search criteria',
      notFoundOnlyUsers: 'No users matching your search criteria',
      notFoundWithGroups: 'No users or groups matching your search criteria'
    }
  },
  cards: {
    tooltips: {
      notSharedYet: 'Not shared yet',
      sharedWithOrganization:
        '{usersCount, plural, one {Shared with 1 member} other {Shared with all {usersCount} members}}',
      sharedWithOrganizationGroups:
        'Shared with {groupsCount} {groupsCount, plural, one {group} other {groups}}{usersCount, plural, =0 {} other { and {usersCount} {usersCount, plural, one {member} other {members}}}}',
      sharedWithRestricted: 'Shared with {usersCount} users',
      sharedWithRestrictedGroups:
        'Shared with {groupsCount} {groupsCount, plural, one {group} other {groups}}{usersCount, plural, =0 {} other { and {usersCount} {usersCount, plural, one {member} other {members}}}}',
      anyoneInOrganization: 'Anyone in {orgName} has access',
      onlyInvitedPeople: 'Only invited people have access'
    }
  }
}
